import React, { Component } from "react";
import { Link } from "react-router-dom";

class CommentRecommendation extends Component {
  state = {};
  render() {
    const arrayComment = this.props.comment.split(" ");
    const style = { cursor: "pointer", color: "black" };

    var comments = arrayComment.map(function(word, index) {
      if (word.charAt(0) === "@") {
        if (word.slice(1).length > 0) {
          return (
            <Link key={index} style={style} to={"/users/" + word.slice(1)}>
              <span>{word} </span>
            </Link>
          );
        }
      } else if (word.charAt(0) === "#") {
        if (word.slice(1).length > 0) {
          return (
            <Link key={index} style={style} to={"/hashtag/" + word.slice(1)}>
              <span>{word} </span>
            </Link>
          );
        }
      }
      return <React.Fragment key={index}>{word} </React.Fragment>;
    });

    return <React.Fragment>{comments}</React.Fragment>;
  }
}

export default CommentRecommendation;



// WEBPACK FOOTER //
// ./src/components/recommendation/comment_recommendation.jsx